'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdMemory = function MdMemory(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.4 28.4v-16.8h-16.8v16.8h16.8z m6.6-10h-3.4v3.2h3.4v3.4h-3.4v3.4c0 1.8-1.4 3.2-3.2 3.2h-3.4v3.4h-3.4v-3.4h-3.2v3.4h-3.4v-3.4h-3.4c-1.8 0-3.2-1.4-3.2-3.2v-3.4h-3.4v-3.4h3.4v-3.2h-3.4v-3.4h3.4v-3.4c0-1.8 1.4-3.2 3.2-3.2h3.4v-3.4h3.4v3.4h3.2v-3.4h3.4v3.4h3.4c1.8 0 3.2 1.4 3.2 3.2v3.4h3.4v3.4z m-13.4 3.2v-3.2h-3.2v3.2h3.2z m3.4-6.6v10h-10v-10h10z' })
        )
    );
};

exports.default = MdMemory;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/memory.js
// module id = 3547
// module chunks = 168707334958949